export default function LoadingSpinner({ bgColor = 'bg-[#FAF8F5]' }: { bgColor?: string }) {
  return (
    <div className={`min-h-screen ${bgColor} flex items-center justify-center`}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B1538] mx-auto" />
        <p className="mt-4 text-gray-600">Lädt...</p>
      </div>
    </div>
  );
}
